<template>
  <div>
    <div v-if="loadingStatus">
      <v-row>
        <v-col cols="12" md="4" sm="4" class="mx-auto" v-for="n in 6" :key="n">
          <v-skeleton-loader
            :loading="loadingStatus"
            class="ma-2"
            type="card@2"
            elevation="2"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row class="ma-2" justify="center">
        <v-col cols="12" sm="4" md="4" v-for="data in gameDay" :key="data._id">
          <v-card class="my-2" rounded min-height="420">
            <!-- logo -->
            <v-row class="mx-1" justify="space-between">
              <!-- home -->
              <!-- //todo.. optimal way to set image -->
              <v-col md="2">
                <p class="text-center">
                  {{ data.HomeTeam }}

                  <v-img
                    max-height="50"
                    max-width="50"
                    :src="data.HomeTeamLogo"
                  ></v-img>
                </p>
              </v-col>
              <!-- //todo.. optimal way to set image -->

              <!-- over under & date -->
              <v-col md="5">
                <p class="text-center blue--text">
                  {{ data.DateTime | DatetimeFormat }}
                </p>
              </v-col>

              <!-- away -->
              <v-col md="2">
                <p class="text-center">
                  {{ data.AwayTeam }}
                  <v-img
                    max-height="50"
                    max-width="50"
                    :src="data.AwayTeamLogo"
                  ></v-img>
                </p>
              </v-col>
            </v-row>
            <!-- logo ends..-->

            <v-sheet class="px-2" color="#81C784">
              <v-row justify="space-between">
                <!-- home -->
                <v-col md="4">
                  <p class="body-2 text-start">
                    Money Line :
                    <span class="font-weight-medium"
                      >{{ data.HomeTeamMoneyLine }}
                    </span>
                  </p>
                </v-col>

                <!-- over under -->
                <v-col md="4">
                  <p class="body-2 text-center black--text font-weight-medium">
                    <span class="font-weight-regular">Over Under: </span>
                    {{ data.OverUnder }}
                  </p>
                </v-col>

                <!-- away -->
                <v-col md="4">
                  <p class="body-2 text-end">
                    Money Line :
                    <span class="font-weight-medium">
                      {{ data.AwayTeamMoneyLine }}</span
                    >
                  </p>
                </v-col>
              </v-row>
            </v-sheet>

            <!-- pitcher -->

            <!-- pitcher ends-->

            <!--//* lineup status -->
            <v-sheet class="px-2" color="#FFF59D">
              <v-row justify="space-between">
                <!-- home -->
                <v-col md="6">
                  <p
                    v-if="data.Homelineupstatus == 'Projected'"
                    class="body-2 text-start"
                  >
                    Projected Lineups
                  </p>

                  <p
                    v-if="data.Homelineupstatus == 'Confirmed'"
                    class="body-2 text-start green--text font-weight-medium"
                  >
                    Confirmed Lineups
                  </p>
                </v-col>

                <!-- away -->
                <v-col md="6">
                  <p
                    v-if="data.Awaylineupstatus == 'Projected'"
                    class="body-2 text-end"
                  >
                    Projected Lineups
                  </p>
                  <p
                    v-if="data.Awaylineupstatus == 'Confirmed'"
                    class="body-2 text-end green--text font-weight-medium"
                  >
                    Confirmed Lineups
                  </p>
                </v-col>
              </v-row>
            </v-sheet>
            <!--//* lineup status -->

            <!--//* player list -->
            <v-sheet class="px-3">
              <v-row justify="space-between">
                <!-- #1 HomeTeam-->
                <v-col md="6">
                  <ul
                    v-for="(player, index) in data.HomeBatterLineup"
                    :key="index"
                    style="list-style: none; padding: 2px"
                  >
                    <li class="body-2" v-if="player.Starting">
                      <span class="font-weight-medium text-start">
                        {{ player.Position }}&nbsp;
                      </span>
                      {{ player.FirstName }}
                      {{ player.LastName }}
                    </li>
                  </ul>
                </v-col>

                <!-- #2 AwayTeam -->
                <v-col md="5">
                  <ul
                    v-for="(player, index) in data.AwayBatterLineup"
                    :key="index"
                    style="list-style: none; padding: 2px; 0px;"
                  >
                    <li class="body-2 text-end" v-if="player.Starting">
                      {{ player.FirstName }} {{ player.LastName }}
                      <span class="font-weight-medium text-start">
                        {{ player.Position }}&nbsp;
                      </span>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-sheet>
            <!--//* player list ends-->

            <!-- weather -->
            <!-- <v-card-actions v-if="false" class="weather-div pt-5">
              <v-row justify="center" align="end">
                <v-col md="9" sm="8" cols="12">
                  <p class="subtitle-2 float-start">
                    <v-icon small>mdi-coolant-temperature</v-icon>

                    Temp-High :
                    <span> {{ data.ForecastTempHigh }}&#8457; </span>
                  </p>
                  &nbsp;
                  <p class="subtitle-2 float-end">
                    <v-icon small>mdi-coolant-temperature</v-icon>

                    Temp-Low :
                    <span> {{ data.ForecastTempLow }}&#8457; </span>
                  </p>
                </v-col>

                <v-col md="9" sm="8" cols="12" class="mt-n8">
                  <p class="subtitle-2 float-start">
                    <v-icon small>mdi-weather-windy</v-icon>
                    Wind-Chill :
                    <span> {{ data.ForecastWindChill }}&#8457; </span>
                  </p>
                  &nbsp;
                  <p class="subtitle-2 float-right ">
                    <v-icon small>mdi-weather-windy</v-icon>

                    Wind-speed :
                    <span> {{ data.ForecastWindSpeed }} m/h </span>
                  </p>
                </v-col>

                <v-col md="8" sm="8" cols="8" class="mt-n8">
                  <p class="blue--text subtitle-1 text-center">
                    "{{ data.ForecastDescription }}"
                  </p>
                </v-col>
              </v-row>
            </v-card-actions> -->
            <!-- weather ends-->
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NbaGameDaySection",

  created() {
    this.fetchDailyLineup();
  },

  computed: {
    ...mapState("NbaModule", ["daily_lineups", "loadingStatus"]),

    gameDay() {
      if (this.daily_lineups.teams.length > 0) {
        return this.daily_lineups.teams.slice(0, 1);
      }
    },
  },

  methods: {
    fetchDailyLineup() {
      this.$store.dispatch("NbaModule/getDailyLineup");
    },
  },
};
</script>

<style scoped>
.picther-text:hover {
  cursor: pointer;
  color: rgb(24, 129, 137) !important;
  /* background-color: #94c097; */
}
</style>
